import { useState } from 'react'
import styled from '@emotion/styled'
import { attachFileToMessageV2, StyledTooltip, theme } from 'j-comps'
import SendIcon from '@mui/icons-material/Send'
import ActionDropdown from './ActionDropdown'
import InfoIcon from '@mui/icons-material/Info'
import EditIcon from '@mui/icons-material/Edit'
import { Button, ClickAwayListener } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import MetaData from './MetaData'
import { connect } from 'react-redux'
import { createDesign } from '../../../../../../../data/actions'
import { store } from '../../../../../../..'
import config from '../../../../../../../config'

const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
`

const ActionButton = styled(Button)`
  margin-right: ${theme.spacing.medium};
`

const ActionBar = ({ api, memberId, design, source }) => {
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipToggle = () => {
    setOpen(!open)
  }

  const handleImageClick = async (id) => {
    if (api) {
      api.editDesign({
        editor: { publishLabel: 'Save' },
        design: { id },
        onDesignPublish: ({ designId, exportUrl }) => {
          const isUpdate = true
          createDesign(exportUrl, designId, memberId, isUpdate)
          // Triggered when design is published to an image.
          // Save the image to your server as the exportUrl will expire shortly.
        },
      })
    }
  }

  const handleSendClick = (url) => {
    const secret = config.hs.secret
    const name = `${config.vendor.name.titleCase} Image`
    attachFileToMessageV2({ store, secret, memberId, url, name })
  }

  const EditButton = () => {
    const titleText =
      source === 'stream' ? 'Go to Content Sources to Edit' : 'Edit'
    return (
      <Tooltip title={titleText} aria-label={'Edit Design'}>
        <span>
          <ActionButton
            disabled={source === 'stream'}
            onClick={() => handleImageClick(design.id)}
          >
            <EditIcon />
          </ActionButton>
        </span>
      </Tooltip>
    )
  }

  return (
    <ActionButtons>
      <ActionButton>
        <Tooltip
          title={'Send to Composer'}
          aria-label={'Send to Hootsuite Composer'}
        >
          <SendIcon onClick={() => handleSendClick(design.url)} />
        </Tooltip>
      </ActionButton>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <StyledTooltip
            onClose={handleTooltipClose}
            open={open}
            title={<MetaData design={design} />}
          >
            <ActionButton>
              <Tooltip title={'More Info'} aria-label={'More Info'}>
                <InfoIcon onClick={handleTooltipToggle} />
              </Tooltip>
            </ActionButton>
          </StyledTooltip>
        </div>
      </ClickAwayListener>
      <EditButton />
      <ActionDropdown design={design} onImageClick={handleImageClick} />
    </ActionButtons>
  )
}

const mapStateToProps = (state) => ({
  api: state.api,
  memberId: state.memberId,
  source: state.source,
})
export default connect(mapStateToProps)(ActionBar)
